if (document.querySelector('.iww-mobilenav-with-subnav')) {

    // Click auf Sub-Nav
    document.querySelectorAll('.iww-mobilenav-with-subnav').forEach(function (element) {
        element.addEventListener('click', function (event) {
            event.preventDefault();
            // Perform the necessary actions
            element.querySelector('.iww-mobilenav-icon').classList.toggle('before:rotate-180');
            if (element.querySelector('.iww-mobilesubnav').classList.contains('hidden')) {
                element.querySelector('.iww-mobilesubnav').classList.add('block');
                element.querySelector('.iww-mobilesubnav').classList.remove('hidden');
            } else {
                element.querySelector('.iww-mobilesubnav').classList.add('hidden');
                element.querySelector('.iww-mobilesubnav').classList.remove('block');
            }
        });
    });
}


